import { Product } from './types';

export const LOGO_URL = '/logo/Logo.png';

export const PRODUCTS: Product[] = [
  {
    id: 1,
    name: 'Derma Hongosil',
    description: 'Fórmula mejorada para el tratamiento eficaz de durezas, callos y hongos en la piel. Aplicación tópica para una piel sana y renovada.',
    price: '$25.000 COL',
  imageUrl: '/productos/Derma Hongosil.jpg',
  },
  {
    id: 2,
    name: 'Pomada Alfa (Uso Veterinario)',
    description: 'Bálsamo de uso veterinario con mentol y alcanfor. Ideal para masajes, alivia el dolor y la inflamación en animales.',
    price: '$35.000 COL',
  imageUrl: '/productos/Pomada Alfa (Uso Veterinario) 1.jpg',
  },
  {
    id: 3,
    name: 'Pomada de Árnica, Coca y Marihuana',
    description: 'Pomada antiinflamatoria con una potente combinación de árnica, coca y marihuana. Alivio efectivo para dolores musculares y articulares.',
    price: '$35.000 COL',
  imageUrl: '/productos/Pomada de Árnica, Coca y Marihuana 2.jpg',
  },
  {
    id: 4,
    name: 'Jarabe de Zarzaparrilla',
    description: 'Poderoso purificador de la sangre. Jarabe energético que combate la anemia, debilidad y ayuda a limpiar el hígado y los riñones.',
    price: '$80.000 COL',
  imageUrl: '/productos/Jarabe de Zarzaparrilla.jpg',
  },
  {
    id: 5,
    name: 'Extracto 5 Raíces',
    description: 'Protege y fortalece tu organismo. Indicado para problemas de próstata, vías urinarias y gastritis. Un remedio 100% original del Amazonas.',
    price: '$80.000 COL',
  imageUrl: '/productos/Extracto 5 Raíces.jpg',
  },
  {
    id: 6,
    name: 'Cholagogue Indio del Putumayo',
    description: 'Gran depurativo de la sangre, 100% natural. Fortalece el cerebro, tonifica los nervios y estimula la digestión. Un tónico para la debilidad general.',
    price: '$80.000 COL',
  imageUrl: '/productos/Cholagogue Indio del Putumayo.jpg',
  },
   {
    id: 7,
    name: 'Extracto de Chuchuhuaza',
    description: 'Elaborado a base de corteza de chuchuhuaza y plantas medicinales. Especialmente formulado para aliviar los síntomas de la artritis de forma natural.',
    price: '$80.000 COL',
  imageUrl: '/productos/Extracto de Chuchuhuaza.jpg',
  },
    {
    id: 8,
    name: 'Purgante Vegetal Balsam',
    description: 'Expulsor 100% natural de toda clase de parásitos. Limpia y desintoxica el hígado, ayudando a restaurar el equilibrio digestivo. Elaborado por Indio del Putumayo.',
    price: '$15.000 COL',
    imageUrl: '/productos/Purgante Vegetal Balsam.jpg',
  },
 {
    id: 9,
    name: 'Pomada Varisol',
    description: 'Nueva pomada para el tratamiento y alivio de la vena várice. Un producto de Verde San para mejorar la circulación.',
    price: '$6.200 COL',
    imageUrl: '/productos/Pomada Varisol.jpg',
  },
  {
    id: 10,
    name: 'Ungüento Chocoano',
    description: 'Ungüento genérico de uso externo con propiedades analgésicas y antiinflamatorias, ideal para dolores musculares y golpes.',
    price: '$15.000 COL',
    imageUrl: '/productos/Ungüento Chocoano.jpg',
  },
  {
    id: 11,
    name: 'Crema de Andrinas',
    description: 'Tratamiento facial y corporal para acné, manchas, espinillas, estrías, cicatrices y arrugas prematuras.',
    price: '$10.100 COL',
    imageUrl: '/productos/Crema de Andrinas.jpg',
  },
  {
    id: 12,
    name: 'Pomada Chuchuhuaza YCS',
    description: 'Con fórmula mejorada, esta pomada aprovecha las propiedades del chuchuhuaza para el alivio de dolores articulares y reumáticos.',
    price: '$7.400 COL',
    imageUrl: '/productos/Pomada Chuchuhuaza.jpg',
  },
  {
    id: 13,
    name: 'Pomada Negra',
    description: 'Ungüento rubefaciente de uso externo, diseñado para generar calor y aliviar dolores musculares profundos y contracturas.',
    price: '$20.000 COL',
    imageUrl: '/productos/Pomada Negra.jpg',
  },
  {
    id: 14,
    name: 'Ungüento Incaico',
    description: 'Elaborado por Laboratorio LIPROM, este ungüento combina extractos naturales para aliviar dolores y malestares de forma efectiva.',
    price: '$18.000 COL',
    imageUrl: '/productos/Ungüento Incaico.jpg',
  },
  {
    id: 15,
    name: 'Crema de Azufre',
    description: 'Fórmula con Penicilina Antibacterial. Especialmente indicada para el tratamiento de afecciones cutáneas como acné, barros y espinillas.',
    price: '$22.000 COL',
    imageUrl: '/productos/Crema de Azufre.jpg',
  },
  {
    id: 16,
    name: 'Crema Caléndula con Azufre',
    description: 'Combina las propiedades cicatrizantes y antiinflamatorias de la caléndula con el poder antiséptico del azufre para el cuidado de la piel.',
    price: '$20.000 COL',
    imageUrl: '/productos/Crema Caléndula con Azufre.jpg',
  },
];

export const SERVICES: string[] = [
  'Sobadas (lesiones y fracturas)',
  'Limpieza energética (mal de ojo)',
  'Tratamiento del "descuajo" infantil',
  'Recomendación de medicina ancestral (Yagé, plantas, pomadas)',
  'Armonización y equilibrio espiritual',
  'Consulta personalizada',
  
];

export const COLOMBIAN_HOLIDAYS: string[] = [
  // 2024
  '2024-01-01', '2024-01-08', '2024-03-25', '2024-03-28', '2024-03-29',
  '2024-05-01', '2024-05-13', '2024-06-03', '2024-06-10', '2024-07-01',
  '2024-07-20', '2024-08-07', '2024-08-19', '2024-10-14', '2024-11-04',
  '2024-11-11', '2024-12-08', '2024-12-25',
  // 2025
  '2025-01-01', '2025-01-06', '2025-03-24', '2025-04-17', '2025-04-18',
  '2025-05-01', '2025-06-02', '2025-06-23', '2025-06-30', '2025-07-20',
  '2025-08-07', '2025-08-18', '2025-10-13', '2025-11-03', '2025-11-17',
  '2025-12-08', '2025-12-25',
];

// --- EmailJS Credentials ---
// IMPORTANT: Replace placeholder values with your actual credentials.

// For new appointments (original account)
export const BOOKING_PUBLIC_KEY = 'y8qN_BNnxm2aMjFKC';
export const BOOKING_SERVICE_ID = 'service_jp5auoj';
export const BOOKING_CLIENT_TEMPLATE_ID = 'template_2bio6kd';
export const BOOKING_DOCTOR_TEMPLATE_ID = 'template_v9tvb5r';

// For rescheduling appointments (new account)
export const RESCHEDULE_PUBLIC_KEY = 'oQn5I1FLMWwogeP3p'; 
export const RESCHEDULE_SERVICE_ID = 'service_c9mn2vl'; 
export const RESCHEDULE_CLIENT_TEMPLATE_ID = 'template_vm8vyox';
export const RESCHEDULE_DOCTOR_TEMPLATE_ID = 'template_la74c23';

// For user cancelling appointments (new account)
export const CANCEL_PUBLIC_KEY = 'j77WUmbGakr8qsWCR';
export const CANCEL_SERVICE_ID = 'service_gnp3r16';
export const CANCEL_CLIENT_TEMPLATE_ID = 'template_qk6r8in';
export const CANCEL_DOCTOR_TEMPLATE_ID = 'template_t2gbcyn';

// For Taita cancelling appointments (new account, new templates)
export const ADMIN_CANCEL_PUBLIC_KEY = 'kloMGEM0nevCyf8ZD';
export const ADMIN_CANCEL_SERVICE_ID = 'service_oak7wpy';
export const ADMIN_CANCEL_CLIENT_TEMPLATE_ID = 'template_1fllf2a'; // Template: Admin cancels, notify client
export const ADMIN_CANCEL_DOCTOR_TEMPLATE_ID = 'template_xoklq82'; // Template: Admin cancels, notify admin
